import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "react-query";
import { Organization } from "../../types/api/User";
import { Get } from "../utils/api";

export default (org_id: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<unknown, Error, Organization>(
    `organization_${org_id}`,
    async () => {
      return await Get<Organization>(
        `/api/organization/${org_id}`,
        await getAccessTokenSilently()
      );
    }
  );
};
